import { render, staticRenderFns } from "./FamiliesDescription.vue?vue&type=template&id=b1878694&scoped=true"
import script from "./FamiliesDescription.vue?vue&type=script&lang=js"
export * from "./FamiliesDescription.vue?vue&type=script&lang=js"
import style0 from "./FamiliesDescription.vue?vue&type=style&index=0&id=b1878694&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1878694",
  null
  
)

export default component.exports